export default __webpack_public_path__ + "static/inventory-optimisation-1--mobile-2c898fc651a937cf12b4cbed3c55d70c.png";